export const INSTANCE_KEY = 'sdk.instance';
